import { Box, Switch, Typography, Tooltip } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { ViewModeToggleProps } from './types';
import './ViewModeToggle.scss';

export const ViewModeToggle = ({
  value,
  onChange,
  disabled = false,
}: ViewModeToggleProps) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.checked ? 'processed' : 'raw');
  };

  return (
    <Box className="viewModeToggle">
      <Typography
        className={`viewModeToggle__label ${value === 'raw' ? 'viewModeToggle__label--active' : ''}`}
        onClick={() => !disabled && onChange('raw')}
      >
        Raw Data
      </Typography>
      <Switch
        checked={value === 'processed'}
        onChange={handleChange}
        disabled={disabled}
        size="small"
        color="primary"
      />
      <Typography
        className={`viewModeToggle__label ${value === 'processed' ? 'viewModeToggle__label--active' : ''}`}
        onClick={() => !disabled && onChange('processed')}
      >
        Processed Data
      </Typography>
      <Tooltip title="Raw = original data | Processed = after template rules">
        <InfoIcon
          sx={{
            fontSize: 16,
            color: 'text.secondary',
            ml: 0.5,
            cursor: 'help',
          }}
        />
      </Tooltip>
    </Box>
  );
};
